import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=08f96c8a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f96c8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f96c8a')) {
      api.createRecord('08f96c8a', component.options)
    } else {
      api.reload('08f96c8a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=08f96c8a&scoped=true&", function () {
      api.rerender('08f96c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I50zaeURC6Je/JS/comp/Accordion.vue"
export default component.exports